import type {
	actionOnOrderInput,
	getAdminDashboardInput,
	getAllPaymentsInput,
	getSenderOwnersInput,
	getTicketsInput,
	getUsersFacetsInput,
	getUsersInput,
	updateStSettingInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetAdminUsers: getUsersInput;
	useGetAdminUsersFacets: getUsersFacetsInput;
	useCreateAdminUser: undefined;
	useUpdateAdminUser: undefined;
	useAdminResetPassword: undefined;
	useActionOnOrder: actionOnOrderInput;
	useGetStSetting: undefined;
	useUpdateStSetting: updateStSettingInput;
	useGetAdminDashboard: getAdminDashboardInput;
	useGetTickets: getTicketsInput;
	useGetTicketsCount: undefined;
	useUpdateTicket: undefined;
	useGetSenderOwners: getSenderOwnersInput;
	useGetCommissionSummary: undefined;
	useGetAllPayments: getAllPaymentsInput;
}

const ADMIN_SERVICE_KEYS = createReactQueryKeys<Keys>("adminUsers", [
	"useGetAdminUsers",
	"useGetAdminUsersFacets",
	"useCreateAdminUser",
	"useUpdateAdminUser",
	"useAdminResetPassword",
	"useActionOnOrder",
	"useGetStSetting",
	"useUpdateStSetting",
	"useGetAdminDashboard",
	"useGetTickets",
	"useGetTicketsCount",
	"useUpdateTicket",
	"useGetSenderOwners",
	"useGetCommissionSummary",
	"useGetAllPayments",
]);

export { ADMIN_SERVICE_KEYS };
